import {createTextVariant} from './Text.js'

export default createTextVariant('h2', 'H2')
